<template>
  <div class="mobile-search mobile" v-if="!loading">
    <el-backtop></el-backtop>
    <div class="mobile-search-search">
      <el-input placeholder="请输入内容" v-model="keyword" @keyup.enter.native="search()">
        <i slot="prefix" class="el-input__icon el-icon-search"></i>
      </el-input>
    </div>
    <div class="mobile-search-experts" v-if="experts.length" id="experts">
      <div class="mobile-search-expert" v-for="(item,index) in experts" :key="index">
        <div class="expert-header">
          <div class="expert-img">
            <router-link
              :to="{path:'/Mobile/Detail',query: /^\d+$/.test(item.kId)? {kId:item.kId } :{name:item.name,institute:item.organization}}"
            >
              <el-image
                class="exp-header"
                :src="item.avatarUrl?'/old/public'+item.avatarUrl:'http://expert.ckcest.cn/autoload/images/avatar.png'"
                fit="contain"
              >
                <div slot="error" class="image-slot">
                  <img
                    width="80px"
                    height="100px"
                    src="http://expert.ckcest.cn/autoload/images/avatar.png"
                  />
                </div>
              </el-image>
            </router-link>
          </div>
          <div class="expert-info">
            <router-link
              :to="{path:'/Mobile/Detail',query: /^\d+$/.test(item.kId)? {kId:item.kId } :{name:item.name,institute:item.organization}}"
            >
              <p style="font-weight:700">{{item.name}} {{item.honor}}</p>
            </router-link>
            <p>{{item.organization}}</p>
            <p>{{/^[0-9]+$/.test(item.kId) ? '已认领' : '未认领'}}</p>
            <p>{{item.isni?'INSI:'+item.isni.replace(/(.{4})/g,'$1-').slice(0,item.isni.length+3) :''}}</p>
          </div>
        </div>
        <div class="expert-body">
          <p>{{item.subject?'学科：'+item.subject:''}}</p>
        </div>
        <div class="expert-footer" v-if="item.keyword">
          <div v-for="li in item.keyword.split(';').slice(0,20)" :key="li">
            <span v-if="li">{{li}}</span>
          </div>
        </div>
        <div class="expert-footer" v-else style="background-color: #fff;"></div>
      </div>
    </div>
    <div class="loading" style="height:50px" v-if="loading1" v-loading="true"></div>
    <div v-if="!total" style="text-align: center;margin-top: 30vh;">
      <span>当前检索条件无有效检索结果请重试</span>
    </div>
    <div class="loading" style="height:40px;display:flex" v-if="more">
      <span style="margin:auto">已经最底部了</span>
    </div>
  </div>
  <div style="height:100vh;width:100vw" v-else v-loading="true"></div>
</template>

<script>
import { search } from "@/api/common";
export default {
  name: "search",
  data() {
    return {
      keyword: this.$route.query.key,
      loading: false,
      loading1: false,
      total: 0,
      experts: [],
      busy: false,
      more: false,
    };
  },
  methods: {
    search() {
      this.loading = true;
      this.from = 0;
      this.more = false;
      let data = {
        k: this.keyword,
        from: this.from * 10,
        size: 10
      };
      search(data).then(res => {
        this.loading = false;
        this.experts = res.data.obj;
      });
    },
    getScroll(e) {
      this.$nextTick(() => {
        if (
          this.loading ||
          this.$route.path.toLowerCase() !== "/mobile/search"
        ) {
          return;
        }
        if (!document.getElementById("experts")) {
          return;
        }
              if (this.total <= this.experts.length) {
          this.more = true;
          return;
        }
        let dom = document.getElementById("experts").offsetHeight;
        let hieght = document.documentElement.clientHeight;
        var top = Math.floor(
          document.body.scrollTop ||
            document.documentElement.scrollTop ||
            window.pageXOffset
        );
        if (top + hieght > dom) {
          if (this.loading1) {
            return;
          }
          this.from++;
          this.dronDown();
        }
      });
    },
    dronDown() {
      this.loading1 = true;
      let data = {
        k: this.keyword,
        from: this.from * 10,
        size: 10
      };
      search(data).then(res => {
        this.loading1 = false;
        this.experts = this.experts.concat(res.data.obj);
      });
    }
  },
  mounted() {
    window.addEventListener("scroll", this.getScroll, true);
    if (this.keyword) {
      this.search();
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.getScroll); // 监听页面滚动事件
  },
  components: {}
};
</script>

<style lang="scss">
.mobile-search {
  margin-top: 20px;
  .mobile-search-search {
    margin: 20px 0;
    input {
      border-radius: 20px;
    }
  }
  .mobile-search-experts {
    margin: 20px 0;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    .mobile-search-expert {
      padding: 10px;
      border: 1px #ccc solid;
      margin-top: 10px;
      .expert-header {
        display: flex;
        .expert-img {
          width: 30%;
        }
        .expert-info {
          padding: 0 10px;
          width: 70%;
          p {
            margin-bottom: 5px;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
        }
      }
      .expert-body {
        p {
          height: 20px;
          margin-top: 5px;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }
      }
      .expert-footer {
        background-color: #f5f5f5;
        height: 44px;
        overflow: hidden;
        margin-top: 5px;
        div {
          height: 20px;
          flex-shrink: 1;
          float: left;
          border: 1px #ccc solid;
          padding: 1px 2px;
          border-radius: 4px;
          font-size: 12px;
          margin: 0 4px 2px 0;
        }
      }
    }
    @media screen and (max-width: 576px) {
      .mobile-search-expert {
        width: 98%;
      }
    }
    @media screen and (min-width: 576px) {
      .mobile-search-expert {
        width: 48%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/mobile/Search.vue